<template>
    <div>
        <div class='footer-column-title'>
            Resources
        </div>
        <div class='footer-column-links'>
            <div @click="onClickLink('resources/documentation')"><a class="footer-link">Documentation</a></div>
            <div @click="onClickLink('resources/support')"><a class="footer-link">Support</a></div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        onClickLink(page, external = false) {
            if(external) {
                window.open(page, '_blank');
            } else {
                this.$router.push(`/${page}`);
            }
        }
    }
}
</script>